import './styles.css'

export default function MembersAvatars({ config }) {
    console.log('membt', config)
    return (
        <div className='avatars-box' style={{ ...(config.style || {}) }}>
            <div className='avatars-row'>
                {
                    config.avatars.map((a, i) => (
                        <img style={{
                            opacity: 0.2 + (i * 0.19),
                            zIndex: i + 1
                        }} className='avatar' src={a} key={i} />
                    ))
                }
            </div>
            {
                config.text && <p style={{
                    color: (config.variant === "LIGHT" || !config.variant) ? 'var(--color-light)' : 'var(--color-dark)'
                }}>{config.text}</p>
            }
        </div>
    )
}